export default __webpack_public_path__ + "static/media/reckless-icon-active.7f711817.svg";